/**
 * @desc 更新消息未读/已读状态
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 除了报警其余传id,报警单独传relevancyId */
  id: number;
  /** 通知类型(0:生产计划，1:报警，2:事件，3:库容) */
  type: number;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/web/notify/updateState',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/web/notify/updateState',

    params,
  });
}
